import { Store, select } from '@ngrx/store';
import {
  createSelector,
  createFeatureSelector,
  ActionReducerMap
} from '@ngrx/store';
import * as fromSite from './sites.reducer';
import { Site } from '../../sites.model';

// export const reducers: ActionReducerMap<any> = {
//   message: fromSite.siteReducer
// };

export const selectSiteState = createFeatureSelector<fromSite.State>('siteReducer');


export const { selectAll: selectAllSites } = fromSite.siteAdapter.getSelectors(
  selectSiteState
);

export const selectAddSiteCompleted = createSelector(selectSiteState,
  fromSite.getSiteStatus
);
// export const { selectEntities: selectAllEntities } = fromSite.siteAdapter.getSelectors(
//   selectSiteState
// );

// export const { selectAll: selectAllSitesByCompanyId } = fromSite.siteAdapter.getSelectors(
//   selectSiteState
// );


export const selectAllCourses = createSelector(
  selectSiteState,
  sitesState => {
    const allCourses = Object.values(sitesState.entities);
    allCourses.sort();
    return allCourses;
  }
);

export const {
  selectIds: siteIds,
  selectEntities: siteEntities,
  selectAll: allSites,
  selectTotal: totalsites
} = fromSite.siteAdapter.getSelectors(selectSiteState);

export const selectSitesByCompanyId = createSelector(
  allSites,
  (sites: Site[], { id }: { id: string }) => sites.filter(site => site.companyId === id)
);

export const selectSitesByCompanyIdAndBranchManager = createSelector(
  allSites,
  (sites: Site[], { id, branchManagerEmail }: { id: string , branchManagerEmail: string }) => sites.filter(site => site.companyId === id && site.email === branchManagerEmail)
);

export const selectSitesByCompanyIdAndBranchManager3 = createSelector(
  allSites,
  (sites: Site[], { id, branchManagerUserId }: { id: string , branchManagerUserId: string }) => sites.filter(site => site.companyId === id && site.userId === branchManagerUserId)
);

export const selectSitesBySiteId = createSelector(
  allSites,
  (sites: Site[], { siteId }: { siteId: string }) => sites.filter(site => site.id === siteId)
);

// ToBeDone

// export const selectSitesByCompanyIdAndAreaManager = createSelector(
//   allSites,
//   (sites: Site[], { id, areaManagerIds }: { id: string , areaManagerIds: string }) => sites.filter(site => site.companyId === id && site.id === []])
// );

// export const selectSitesByCompanyIdAndAreaManager = createSelector(
//   allSites,
//   (sites: Site[], { id, areaManagerEmail }: { id: string , areaManagerEmail: string }) => sites.filter(site => site.companyId === id && site.email == areaManagerEmail)
// );

export const selectSitesByCompanyIdAndGroupId = createSelector(
  allSites,
  (sites: Site[], { companyId, groupId }: { companyId: string , groupId: string }) => sites.filter(site => site.companyId === companyId && site.groupId === groupId)
);

export const selectSitesByCompanyIdAndSiteId = createSelector(
  allSites,
  (sites: Site[], { companyId, siteId }: { companyId: string , siteId: string }) => {
    return  sites.filter(site => site.companyId === companyId && site.id === siteId);
  }
);
